import { RestService } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ArtikelGruppen } from '../../store/models/artikelgruppen';

@Injectable({
    providedIn: 'root'
})
export class ArtikelGruppenService {

    constructor(
        private restService: RestService,
    ) { }

    getList(
        pageNumber?: number,
        pageSize?: number,
        sortField: string = "reihenfolge",
        sortDirection: string = "asc"
    ) : Observable<ArtikelGruppen.Response> {

        let skipCount = pageNumber * pageSize;
        let sorting = sortField + ' ' + sortDirection;

        return this.restService.request<void, ArtikelGruppen.Response>({
            method: 'GET',
            url: '/api/app/artikel-gruppe?Sorting=' + sorting + '&SkipCount=' + skipCount + '&MaxResultCount=' + pageSize
        });
    }

    getListFilter(
        pageNumber?: number,
        pageSize?: number,
        sortField: string = "reihenfolge",
        sortDirection: string = "asc",
        filter: string = "",
        searchTerm: string = "",
    ) : Observable<ArtikelGruppen.Response> {

        let skipCount = pageNumber * pageSize;
        let sorting = sortField + ' ' + sortDirection;

        return this.restService.request<void, ArtikelGruppen.Response>({
            method: 'GET',
            url: '/api/app/artikel-gruppe/filter?Sorting=' + sorting + '&SkipCount=' + skipCount + '&MaxResultCount=' + pageSize + '&filter=' + filter + '&searchTerm=' + searchTerm
        });
    }

    getListReihenfolge(): Observable<ArtikelGruppen.IReihenfolgeDto> {
        return this.restService.request<void, ArtikelGruppen.IReihenfolgeDto>({
            method: 'GET',
            url: '/api/app/artikel-gruppe/reihenfolge'
        });
    }

    getListReihenfolgeTree(all:boolean=false) : Observable<ArtikelGruppen.IArtikelGruppeListDto>{
        return this.restService.request<void, ArtikelGruppen.IArtikelGruppeListDto>({
            method: 'GET',
            url: '/api/app/artikel-gruppe/reihenfolge-tree?All=' + (all==true?"true":"false")
        });
    };

    getById(id: number): Observable<ArtikelGruppen.IArtikelGruppeDto> {
        return this.restService.request<void, ArtikelGruppen.IArtikelGruppeDto>({
            method: 'GET',
            url: '/api/app/artikel-gruppe/' + id
        });
    }
}